import { createSlice } from '@reduxjs/toolkit';

const INIT_STATE = {
  activeName: 'column',
  column: {
    brickCountVertically: 8,
    brickCountHorizontally: 3,
  },
  fundament: {
    brickCountVertically: 3,
    brickCountHorizontally: 10,
  },
  door: {
    cmHorizontally: 100,
    type: 'simple',
  },
};

const editNewElementPropsHandler = (state, payload) => {
  state = { ...state, ...payload };
  return state;
};

const newElementSlice = createSlice({
  name: 'newElement',
  initialState: INIT_STATE,
  reducers: {
    editNewElementProps: (state, action) => editNewElementPropsHandler(state, action.payload),
  },
});

export const { editNewElementProps } = newElementSlice.actions;

export default newElementSlice.reducer;
